import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Chart from 'chart.js'
import { formatPriceWithLocalizedCurrency } from '../../lib/helpers'
import styles from './PriceHistoryGraph.module.sass'

class PriceHistoryGraph extends Component {
  _pointBackgroundColors = () => {
    const defaultColor = 'rgb(130, 130, 131)'
    const accentColor = 'rgb(104, 104, 104)'
    return Array.from({length: this.props.pricesData.length}, (_e, i) => i + 1 === this.props.pricesData.length ? accentColor : defaultColor)
  }

  _percentageToInfluencePrices = () => 0.1

  _suggestedMaximumPrice = () => {
    const maxPrice = Math.max(...this.props.pricesData.map(priceData => priceData.price))
    return maxPrice + maxPrice * this._percentageToInfluencePrices()
  }

  _suggestedMinimumPrice = () => {
    const minPrice = Math.min(...this.props.pricesData.map(priceData => priceData.price))
    return minPrice + minPrice * this._percentageToInfluencePrices()
  }

  componentDidMount() {
    const node = this.node
    const { pricesData, locale, currency } = this.props

    new Chart(node, {
      type: 'line',
      data: {
        labels: pricesData.map(priceData => priceData.dateShort),
        datasets: [
          {
            data: pricesData.map(priceData => priceData.price),
            borderColor: ['rgb(130, 130, 131)'],
            pointBackgroundColor: this._pointBackgroundColors(),
            pointBorderColor: this._pointBackgroundColors(),
            pointRadius: 3,
            fill: false,
            lineTension: 0,
            borderWidth: 2,
          },
        ],
      },
      options: {
        tooltips: {
          mode: 'point',
          callbacks: {
            label: (tooltipItem, data) => {
              let label = data.datasets[tooltipItem.datasetIndex].label || ''
              label += formatPriceWithLocalizedCurrency(this.props.pricesData[tooltipItem.index].price, this.props.locale, this.props.currency)
              return label
            },
          },
        },
        legend: {
          display: false,
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawTicks: false,
              display: false,
            },
            ticks: {
              maxTicksLimit: 3,
              padding: 20,
            },
          }],
          yAxes: [{
            ticks: {
              maxTicksLimit: 3,
              padding: 0,
              suggestedMin: this._suggestedMinimumPrice(),
              suggestedMax: this._suggestedMaximumPrice(),
              callback: label => formatPriceWithLocalizedCurrency(label, locale, currency),
            },
          }],
        },
      },
    })
  }

  render() {
    return (
      <div>
        <p className='car-details-panel__section-heading'>{this.props.graphTitle}</p>

        <ul className={styles.graph__discounts}>
          { this.props.pricesData.map(priceData => (
            <li key={priceData.price}>
              <p>{priceData.dateShortForTable}</p>
              <p>{formatPriceWithLocalizedCurrency(priceData.price, this.props.locale, this.props.currency)}</p>
            </li>
          ))}
        </ul>

        <canvas
          style={{ height: 250 }}
          ref={node => (this.node = node)}
        />
      </div>
    )
  }
}

PriceHistoryGraph.propTypes = {
  pricesData: PropTypes.array,
  graphTitle: PropTypes.string,
  locale: PropTypes.string,
  currency: PropTypes.string,
}

export default PriceHistoryGraph
